module.exports = __webpack_public_path__ + "static/media/006.f747915a.svg";